import Vue from 'vue'

import TemplateView from './components/Template.vue'
// import LoginView from './components/Login.vue'
// import DashboardView from './components/views/Dashboard.vue'
import VueRouter from 'vue-router'

import store from './store'
import { EventBus } from './core/event-bus.js'
import localStorage from './core/local-storage'
import { sync } from 'vuex-router-sync'

const LoginView = () => import('@/components/Login')
const DashboardView = () => import('@/components/views/Dashboard')
const ProyectoInfoView = () => import('@/components/views/proyectos/Info')
const ProyectoLinkView = () => import('@/components/views/proyectos/Link')
const ProyectoIframeView = () => import('@/components/views/proyectos/Iframe')
const ProyectoRMView = () => import('@/components/views/reportes-media/')
const ProyectoComprasView = () => import('@/components/views/compras/Index')
const ProyectoParteDiarioView = () => import('@/components/views/partes-diarios/')
const Error404View = () => import('@/components/404')

Vue.use(VueRouter)

// Routes
const routes = [
  {
    path: '/login',
    component: LoginView,
    meta: {description: 'Login', requiresGuest: true}
  },
  {
    path: '/',
    component: TemplateView,
    children: [
      {
        path: 'dashboard',
        alias: '',
        component: DashboardView,
        name: 'dashboard',
        meta: {description: 'Movimientos de mercaderia', requiresAuth: true}
      },
      {
        path: 'proyecto/:codigo_proyecto/info',
        alias: 'Info',
        component: ProyectoInfoView,
        name: 'proyecto_info',
        meta: {description: 'Informacion', requiresAuth: true},
        props: true
      },
      {
        path: 'proyecto/:codigo_proyecto/link',
        alias: 'Link',
        component: ProyectoLinkView,
        name: 'proyecto_link',
        meta: {description: 'Link', requiresAuth: true},
        props: true
      },
      {
        path: 'proyecto/:codigo_proyecto/iframe/:index',
        alias: 'Iframe',
        component: ProyectoIframeView,
        name: 'proyecto_iframe',
        meta: {description: 'Iframe', requiresAuth: true},
        props: true
      },
      {
        path: 'proyecto/:codigo_proyecto/reportes-media',
        alias: 'Reportes',
        component: ProyectoRMView,
        name: 'proyecto_rm',
        meta: {description: 'Reportes & Media', requiresAuth: true},
        props: true
      },
      {
        path: 'proyecto/:codigo_proyecto/compras',
        alias: 'Compras',
        component: ProyectoComprasView,
        name: 'compras',
        meta: {description: 'Compras', requiresAuth: true},
        props: true
      },
      {
        path: 'proyecto/:codigo_proyecto/parte-diario',
        alias: 'Parte Diario',
        component: ProyectoParteDiarioView,
        name: 'parte_diario',
        meta: {description: 'Compras', requiresAuth: true},
        props: true
      },
      {
        path: 'mis-compras/:tabla',
        alias: 'MisCompras',
        component: ProyectoComprasView,
        name: 'mis_compras',
        meta: {description: 'Mis compras', requiresAuth: true},
        props: true
      },
      {
        path: 'formularios/parte-diario',
        alias: 'Parte Diario',
        component: ProyectoParteDiarioView,
        name: 'parte_diario',
        meta: {description: 'Compras', requiresAuth: true}
      }
    ]
  }, {
    // not found handler
    path: '*',
    component: Error404View
  }
]

var router = new VueRouter({
  routes: routes,
  linkExactActiveClass: 'active',
  scrollBehavior: function (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  store.commit('HIDE_GENERAL_ALERT')

  if (to.meta.requiresAuth) {
    if (store.state.user || localStorage.getToken()) {
      if (window.innerWidth < 768) {
        EventBus.$emit('COLAPSAR MENU')
      }
      next()
    } else {
      next({
        path: '/login'
      })
    }
  }
  if (to.meta.requiresGuest) {
    if (store.state.user || localStorage.getToken()) {
      next({name: 'dashboard'})
    } else {
      next()
    }
  }
})

sync(store, router)

export default router



// WEBPACK FOOTER //
// ./src/router.js